import { StorageType } from 'components/azure-provider/enums'

export default class Storage {
  constructor(public type: StorageType) {}

  setItem = (key: string, value: string): void => {
    if (this.type === StorageType.sessionStorage)
      sessionStorage.setItem(key, value)
    if (this.type === StorageType.localStorage) localStorage.setItem(key, value)
  }

  getItem = (key: string): string | null => {
    if (this.type === StorageType.sessionStorage)
      return sessionStorage.getItem(key)
    if (this.type === StorageType.localStorage) return localStorage.getItem(key)
    return null
  }

  removeItem = (key: string): void => {
    if (this.type === StorageType.sessionStorage) sessionStorage.removeItem(key)
    if (this.type === StorageType.localStorage) localStorage.removeItem(key)
  }
}
